<script>
import { Helper } from '@/mixin/helper'
import McGraphqlEditableTable from '@/components/McGraphqlEditableTable'
import {
  SERVICES,
  CREATE_SERVICES,
  UPDATE_SERVICES,
  DELETE_SERVICES,
} from '@/services/api/setting/maintenance/setting/services'
import { SERVICE_ACTIONS } from '@/services/api/setting/maintenance/setting/serviceActions'
import { SERVICE_CATEGORIES } from '@/services/api/setting/maintenance/setting/categories'

export default {
  components: {
    McGraphqlEditableTable,
  },
  mixins: [Helper],
  props: {
    status: String,
  },
  data() {
    return {
      showTable: true,
      data: [],
      formErrors: {},
      deleteRes: {},
    }
  },
  computed: {
    fields() {
      return [
        {
          name: 'name',
          key: 'name',
          label: this.$t('maintenance.field.compName'),
          thClass: 'mc-table--50',
          isSortable: true,
          editable: true,
          isEditable: true,
          orderBy: 'asc',
          validation: ['required'],
        },
        {
          name: 'action',
          key: 'serviceAction.action',
          label: this.$t('maintenance.field.activity'),
          placeholder: 'Pilih Aktivitas',
          isEditable: true,
          type: 'select-resourceful',
          trackBy: 'serviceActionId',
          optionsGetter: this.resourcefulQuery.action,
          optionLabelFn: ({ item }) => item.action,
          getInitialObject: (item) => item.serviceAction,
          customValueFn: (item) => item.serviceAction?.serviceActionId ?? 0,
          thStyle: 'width: 300px',
          validation: ['required'],
        },
        {
          name: 'category_name',
          key: 'serviceCategory.name',
          label: this.$t('maintenance.form.catService'),
          placeholder: 'Pilih Kategori',
          isEditable: true,
          type: 'select-resourceful',
          trackBy: 'serviceCategoryId',
          optionsGetter: this.resourcefulQuery.serviceCategory,
          optionLabelFn: ({ item }) => item.name,
          getInitialObject: (item) => item.serviceCategory,
          customValueFn: (item) => item.serviceCategory?.serviceCategoryId ?? 0,
          thStyle: 'width: 300px',
          validation: ['required'],
        },
      ]
    },

    query() {
      return {
        get: async (filter) => {
          const res = await this.$apollo.query({
            fetchPolicy: 'no-cache',
            query: SERVICES,
            variables: {
              filter: filter,
            },
          })
          let self = this
          self.data = res.data.services.services.data

          const result = res.data.services.services
          result.data.forEach((item, index) => {
            if (item.companyId == 1) {
              result.data[index].disableCheckbox = true
              result.data[index].isShowEdit = false
            }
          })
          return result
        },
        store: this.store,
        update: this.update,
        delete: async (id) => {
          const res = await this.$apollo.mutate({
            mutation: DELETE_SERVICES,
            variables: {
              input: {
                serviceId: Number(id),
              },
            },
          })
          return res.data.deleteService.isSuccessful
        },
      }
    },

    resourcefulQuery() {
      return {
        action: async (opts) => {
          const filter = {
            pagination: {
              page: opts.page,
              show: opts.limit,
            },
            search: opts.search,
          }

          const res = await this.$apollo.query({
            fetchPolicy: 'no-cache',
            query: SERVICE_ACTIONS,
            variables: {
              filter: filter,
            },
          })

          const data = res.data.serviceActions.serviceActions
          const result = {
            metadata: {
              total_page: data.pagination.total,
              total_count: data.pagination.total,
              page: data.pagination.page,
            },
            data: {
              paginated_result: data.data,
            },
          }

          return result
        },
        serviceCategory: async (opts) => {
          const filter = {
            pagination: {
              page: opts.page,
              show: opts.limit,
            },
            search: opts.search,
          }

          const res = await this.$apollo.query({
            fetchPolicy: 'no-cache',
            query: SERVICE_CATEGORIES,
            variables: {
              filter: filter,
            },
          })

          const data = res.data.serviceCategories.serviceCategories
          const result = {
            metadata: {
              total_page: data.pagination.total,
              total_count: data.pagination.total,
              page: data.pagination.page,
            },
            data: {
              paginated_result: data.data,
            },
          }

          return result
        },
      }
    },

    buttons() {
      return [
        {
          variant: 'secondary',
          class: 'me-2',
          id: 'cat-service-log-button',
          text: this.$t('global.historyUpdate'),
          icon: 'icon-outline_file-text',
          handleClick: () => {
            this.handleClick()
          },
        },
      ]
    },
  },
  mounted() {
    this.$store.commit('setting/SET_STATUS', this.status)
  },
  methods: {
    handleClick() {
      this.$router.push({ name: 'Log Maintenance Setting', params: { type: 'services' } })
    },
    handleAdd(par) {
      if (par) this.formErrors = {}
    },
    async store(data) {
      const res = await this.$apollo.mutate({
        mutation: CREATE_SERVICES,
        variables: {
          input: {
            name: data.name,
            serviceActionId: data['serviceAction.action'],
            serviceCategoryId: data['serviceCategory.name'],
          },
        },
      })

      this.formErrors = {}
      if (!res.data.createService.isSuccessful) {
        const _errors = {}

        this.fields.forEach((field) => {
          _errors[field.key] = res.data.createService.message
        })

        this.formErrors = { ..._errors }

        return false
      }
      return res.data.createService.createService
    },
    async update(id, oldData, newData) {
      const res = await this.$apollo.mutate({
        mutation: UPDATE_SERVICES,
        variables: {
          input: {
            newData: {
              name: newData.name,
              serviceActionId: newData['serviceAction.action'],
              serviceCategoryId: newData['serviceCategory.name'],
            },
            oldData: {
              name: oldData.name,
              serviceActionId: oldData.serviceActionId,
              serviceCategoryId: oldData.serviceCategoryId,
            },
            serviceId: Number(id),
          },
        },
      })

      this.formErrors = {}
      if (!res.data.updateService.isSuccessful) {
        this.$mcToast.error({
          component: 'McToastDynamicBody',
          props: {
            contents: [
              {
                tag: 'h6',
                text: this.$t('maintenance.alert.editFailed'),
              },
              {
                tag: 'p',
                text: this.$t('maintenance.alert.editUnabled'),
              },
            ],
          },
        })

        const _errors = {}

        this.fields.forEach((field) => {
          _errors[field.key] = res.data.updateService.message
        })

        this.formErrors = { ..._errors }

        return false
      }

      return res.data.updateService.updateService
    },
    reRender() {
      this.$store.commit('setting/SET_STATUS', this.status)
      this.showTable = false
      setTimeout(() => {
        this.showTable = true
      }, 300)
    },

    customToast() {
      this.$mcToast.error({
        component: 'McToastDynamicBody',
        props: {
          contents: [
            {
              tag: 'h6',
              text: this.$t('maintenance.alert.deleteFailed'),
            },
            {
              tag: 'p',
              text: this.$t(`maintenance.errorMessages.ResourceBeingUsed`),
            },
          ],
        },
      })
    },
  },
}
</script>

<template>
  <!-- Rekrutmen -->
  <b-tab class="border-0 pb-4" @click="reRender">
    <template v-slot:title>
      <span class="d-sm-inline-block">{{ $t('maintenance.form.compService') }}</span>
    </template>

    <!-- Table -->
    <McGraphqlEditableTable
      v-if="showTable"
      :fields="fields"
      :buttons="buttons"
      :apiClient="query"
      :searchable="true"
      :formErrors="formErrors"
      trackBy="serviceId"
      :listedDeletedItems="true"
      deletedItemsKey="name"
      @available-change="handleAdd"
      :secondAlertText="$t('maintenance.confirmFooter')"
      :isPredefined="true"
      :customToast="customToast"
    />
  </b-tab>
</template>
